module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bgSet"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "crmAccountActions"
  }, [_c('strong', [_vm._v("CRM账号管理")]), _vm._v(" "), _c('div', {
    staticClass: "crmAccountActions-buttons"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.openCrmDialog('register')
      }
    }
  }, [_vm._v("注册CRM账号")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "edit"
    },
    on: {
      "click": function($event) {
        return _vm.openCrmDialog('password')
      }
    }
  }, [_vm._v("重置CRM密码")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "setting"
    },
    on: {
      "click": function($event) {
        return _vm.openCrmDialog('token')
      }
    }
  }, [_vm._v("重置M令牌")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bgSetting-bottom"
  }, [_c('div', {
    staticClass: "bgSetting-form"
  }, [_c('el-form', {
    ref: "bgSearchFormDatas",
    attrs: {
      "model": _vm.bgSearchFormDatas
    }
  }, [_c('div', {
    staticClass: "loginAccount"
  }, [_c('label', [_vm._v("\n            登录账号\n            "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.bgSearchFormDatas.loginAccountVal),
      callback: function($$v) {
        _vm.$set(_vm.bgSearchFormDatas, "loginAccountVal", $$v)
      },
      expression: "bgSearchFormDatas.loginAccountVal"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bgJurisdiction"
  }, [_c('div', {
    staticClass: "defaultJurisdiction"
  }, [_vm._v("后台权限:\n            "), _c('span', [_vm._v("企业趋势")]), _vm._v(" "), _c('span', [_vm._v("企业统计")])]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.bgSearchFormDatas.bgJurisdictionVal),
      callback: function($$v) {
        _vm.$set(_vm.bgSearchFormDatas, "bgJurisdictionVal", $$v)
      },
      expression: "bgSearchFormDatas.bgJurisdictionVal"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "企业订单",
      "name": "bgJurisdictionVal"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "企业管理",
      "name": "bgJurisdictionVal"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "企业观察",
      "name": "bgJurisdictionVal"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "企业网站",
      "name": "bgJurisdictionVal"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "系统设置",
      "name": "bgJurisdictionVal"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "后台设置",
      "name": "bgJurisdictionVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "funcBtn"
  }, [_c('el-button', {
    on: {
      "click": _vm.searchAccount
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.exportUsersData
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "bgSetting-content"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("登录账号\n              "), _c('i', {
    on: {
      "click": _vm.addAccount
    }
  })]), _vm._v(" "), _c('th', [_vm._v("运营管理后台权限")]), _vm._v(" "), _c('th', [_vm._v("最近一次登录时间")]), _vm._v(" "), _c('th', [_vm._v("操作")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.currentUsersListData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.account))]), _vm._v(" "), _c('td', _vm._l((item.privileges), function(privilege, privilegeIndex) {
      return _c('span', {
        key: privilegeIndex
      }, [_vm._v(_vm._s(_vm._f("filterPageName")(privilege)))])
    }), 0), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.last_login))]), _vm._v(" "), _c('td', [(item.account != 'admin') ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.editAccountBg(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "editBg"
    })]) : _vm._e(), _vm._v(" "), (item.account != 'admin') ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.delAccountBg(item.id, item.account)
        }
      }
    }, [_c('i', {
      staticClass: "deleteBg"
    })]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('subpagination', {
    attrs: {
      "paginationCurrentPage": _vm.currentPage,
      "totalToPag": _vm.companyTotal
    },
    on: {
      "current-change": _vm.getCurrentListData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modelShieldLayer"
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "注册CRM账号",
      "visible": _vm.crmDialogs.register,
      "size": "tiny",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.crmDialogs, "register", $event)
      },
      "close": function($event) {
        return _vm.resetCrmForm('crmRegisterForm')
      }
    }
  }, [_c('el-form', {
    ref: "crmRegisterForm",
    attrs: {
      "model": _vm.crmRegisterForm,
      "rules": _vm.crmRegisterRules,
      "label-width": "96px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "CRM服务器",
      "prop": "server_uid"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择服务器"
    },
    model: {
      value: (_vm.crmRegisterForm.server_uid),
      callback: function($$v) {
        _vm.$set(_vm.crmRegisterForm, "server_uid", $$v)
      },
      expression: "crmRegisterForm.server_uid"
    }
  }, _vm._l((_vm.crmServers), function(server) {
    return _c('el-option', {
      key: server,
      attrs: {
        "label": server,
        "value": server
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业名称",
      "prop": "company"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.crmRegisterForm.company),
      callback: function($$v) {
        _vm.$set(_vm.crmRegisterForm, "company", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "crmRegisterForm.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 160
    },
    model: {
      value: (_vm.crmRegisterForm.email),
      callback: function($$v) {
        _vm.$set(_vm.crmRegisterForm, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "crmRegisterForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "初始密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "maxlength": 64
    },
    model: {
      value: (_vm.crmRegisterForm.password),
      callback: function($$v) {
        _vm.$set(_vm.crmRegisterForm, "password", $$v)
      },
      expression: "crmRegisterForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册来源",
      "prop": "origin"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.crmRegisterForm.origin),
      callback: function($$v) {
        _vm.$set(_vm.crmRegisterForm, "origin", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "crmRegisterForm.origin"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.crmDialogs.register = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.crmSubmitting
    },
    on: {
      "click": _vm.submitCrmRegister
    }
  }, [_vm._v("注册并激活")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "重置CRM密码",
      "visible": _vm.crmDialogs.password,
      "size": "tiny",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.crmDialogs, "password", $event)
      },
      "close": function($event) {
        return _vm.resetCrmForm('crmPasswordForm')
      }
    }
  }, [_c('el-form', {
    ref: "crmPasswordForm",
    attrs: {
      "model": _vm.crmPasswordForm,
      "rules": _vm.crmPasswordRules,
      "label-width": "96px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "CRM服务器",
      "prop": "server_uid"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择服务器"
    },
    model: {
      value: (_vm.crmPasswordForm.server_uid),
      callback: function($$v) {
        _vm.$set(_vm.crmPasswordForm, "server_uid", $$v)
      },
      expression: "crmPasswordForm.server_uid"
    }
  }, _vm._l((_vm.crmServers), function(server) {
    return _c('el-option', {
      key: server,
      attrs: {
        "label": server,
        "value": server
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号/邮箱",
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入CRM账号或登录邮箱",
      "maxlength": 160
    },
    model: {
      value: (_vm.crmPasswordForm.account),
      callback: function($$v) {
        _vm.$set(_vm.crmPasswordForm, "account", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "crmPasswordForm.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "maxlength": 64
    },
    model: {
      value: (_vm.crmPasswordForm.password),
      callback: function($$v) {
        _vm.$set(_vm.crmPasswordForm, "password", $$v)
      },
      expression: "crmPasswordForm.password"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.crmDialogs.password = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.crmSubmitting
    },
    on: {
      "click": _vm.submitCrmPassword
    }
  }, [_vm._v("确认重置")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "重置M令牌",
      "visible": _vm.crmDialogs.token,
      "size": "tiny",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.crmDialogs, "token", $event)
      },
      "close": function($event) {
        return _vm.resetCrmForm('crmTokenForm')
      }
    }
  }, [_c('el-form', {
    ref: "crmTokenForm",
    attrs: {
      "model": _vm.crmTokenForm,
      "rules": _vm.crmTokenRules,
      "label-width": "96px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "CRM服务器",
      "prop": "server_uid"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择服务器"
    },
    model: {
      value: (_vm.crmTokenForm.server_uid),
      callback: function($$v) {
        _vm.$set(_vm.crmTokenForm, "server_uid", $$v)
      },
      expression: "crmTokenForm.server_uid"
    }
  }, _vm._l((_vm.crmServers), function(server) {
    return _c('el-option', {
      key: server,
      attrs: {
        "label": server,
        "value": server
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号/邮箱",
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入CRM账号或登录邮箱",
      "maxlength": 160
    },
    model: {
      value: (_vm.crmTokenForm.account),
      callback: function($$v) {
        _vm.$set(_vm.crmTokenForm, "account", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "crmTokenForm.account"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.crmDialogs.token = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.crmSubmitting
    },
    on: {
      "click": _vm.submitCrmToken
    }
  }, [_vm._v("关闭M令牌")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bgSetting-top"
  }, [_c('div', {
    staticClass: "bgSetting-top-title"
  }, [_c('span', [_vm._v("后台设置")]), _vm._v(" "), _c('div', {
    staticClass: "attention"
  }, [_c('div', {
    staticClass: "attention-model"
  }, [_c('i'), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("登录帐号默认后台权限为企业趋势和企业统计\n              ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v(" 帐号登录后将根据其拥有的权限显示对应的导航栏和界面\n              ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d4950a1","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bgSet/bgSet.vue
// module id = 609
// module chunks = 1